// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Advanced CSS Features for S-CUBUS Website */
/* Modern CSS Grid, Flexbox, Animations, and Micro-interactions */

/* ===== CSS GRID LAYOUTS ===== */

/* Advanced Grid System */
.grid-container {
  display: grid;
  gap: var(--grid-gap);
  width: 100%;
}

/* Responsive Grid Layouts */
.grid-auto-fit {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-6);
}

.grid-auto-fill {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: var(--spacing-4);
}

/* Complex Grid Layouts */
.grid-complex {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 
    "header header header"
    "sidebar main aside"
    "footer footer footer";
  gap: var(--spacing-6);
  min-height: 100vh;
}

.grid-header { grid-area: header; }
.grid-sidebar { grid-area: sidebar; }
.grid-main { grid-area: main; }
.grid-aside { grid-area: aside; }
.grid-footer { grid-area: footer; }

/* Masonry-like Grid */
.grid-masonry {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-auto-rows: masonry;
  gap: var(--spacing-6);
}

/* Card Grid with Subgrid */
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-8);
}

.card-grid-item {
  display: grid;
  grid-template-rows: auto 1fr auto;
  background: var(--color-surface);
  border-radius: var(--radius-xl);
  overflow: hidden;
  transition: var(--transition-all);
  border: 1px solid var(--color-border);
}

.card-grid-item:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: var(--shadow-xl);
  border-color: var(--color-primary);
}

/* ===== ADVANCED FLEXBOX LAYOUTS ===== */

/* Flexible Navigation */
.flex-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--spacing-4);
}

.flex-nav-items {
  display: flex;
  align-items: center;
  gap: var(--spacing-6);
  flex: 1;
}

.flex-nav-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  flex-shrink: 0;
}

/* Flexible Card Layouts */
.flex-cards {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-6);
  justify-content: center;
}

.flex-card {
  flex: 1 1 300px;
  max-width: 400px;
  min-width: 280px;
  display: flex;
  flex-direction: column;
}

.flex-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Centered Content with Flex */
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.flex-center-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: var(--spacing-6);
}

/* Flexible Form Layouts */
.flex-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.flex-form-row {
  display: flex;
  gap: var(--spacing-4);
  flex-wrap: wrap;
}

.flex-form-field {
  flex: 1;
  min-width: 200px;
}

/* ===== ADVANCED ANIMATIONS ===== */

/* Keyframe Animations */
@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromTop {
  from {
    opacity: 0;
    transform: translateY(-100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInFromBottom {
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
  20%, 40%, 60%, 80% { transform: translateX(10px); }
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

@keyframes glow {
  0%, 100% {
    box-shadow: 0 0 5px var(--color-primary);
  }
  50% {
    box-shadow: 0 0 20px var(--color-primary), 0 0 30px var(--color-primary);
  }
}

/* Animation Classes */
.animate-slide-in-left {
  animation: slideInFromLeft 0.6s ease-out forwards;
}

.animate-slide-in-right {
  animation: slideInFromRight 0.6s ease-out forwards;
}

.animate-slide-in-top {
  animation: slideInFromTop 0.6s ease-out forwards;
}

.animate-slide-in-bottom {
  animation: slideInFromBottom 0.6s ease-out forwards;
}

.animate-fade-in-scale {
  animation: fadeInScale 0.6s ease-out forwards;
}

.animate-bounce-in {
  animation: bounceIn 0.8s ease-out forwards;
}

.animate-pulse {
  animation: pulse 2s ease-in-out infinite;
}

.animate-shake {
  animation: shake 0.5s ease-in-out;
}

.animate-rotate {
  animation: rotate 2s linear infinite;
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}

.animate-glow {
  animation: glow 2s ease-in-out infinite;
}

/* Staggered Animations */
.stagger-children > * {
  opacity: 0;
  transform: translateY(30px);
  animation: slideInFromBottom 0.6s ease-out forwards;
}

.stagger-children > *:nth-child(1) { animation-delay: 0.1s; }
.stagger-children > *:nth-child(2) { animation-delay: 0.2s; }
.stagger-children > *:nth-child(3) { animation-delay: 0.3s; }
.stagger-children > *:nth-child(4) { animation-delay: 0.4s; }
.stagger-children > *:nth-child(5) { animation-delay: 0.5s; }
.stagger-children > *:nth-child(6) { animation-delay: 0.6s; }

/* ===== HOVER EFFECTS & MICRO-INTERACTIONS ===== */

/* Button Hover Effects */
.btn-hover-lift {
  transition: var(--transition-all);
}

.btn-hover-lift:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.btn-hover-scale {
  transition: var(--transition-all);
}

.btn-hover-scale:hover {
  transform: scale(1.05);
}

.btn-hover-glow {
  transition: var(--transition-all);
  position: relative;
  overflow: hidden;
}

.btn-hover-glow::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.btn-hover-glow:hover::before {
  left: 100%;
}

/* Card Hover Effects */
.card-hover-lift {
  transition: var(--transition-all);
  cursor: pointer;
}

.card-hover-lift:hover {
  transform: translateY(-10px);
  box-shadow: var(--shadow-2xl);
}

.card-hover-tilt {
  transition: var(--transition-all);
  cursor: pointer;
}

.card-hover-tilt:hover {
  transform: perspective(1000px) rotateX(5deg) rotateY(5deg);
}

.card-hover-zoom {
  overflow: hidden;
  transition: var(--transition-all);
}

.card-hover-zoom img {
  transition: var(--transition-all);
}

.card-hover-zoom:hover img {
  transform: scale(1.1);
}

/* Interactive Elements */
.interactive-element {
  position: relative;
  transition: var(--transition-all);
  cursor: pointer;
}

.interactive-element::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(var(--color-primary-rgb), 0.1);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s, height 0.3s;
}

.interactive-element:hover::after {
  width: 100%;
  height: 100%;
}

/* Ripple Effect */
.ripple {
  position: relative;
  overflow: hidden;
}

.ripple::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(var(--color-primary-rgb), 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.ripple:active::before {
  width: 300px;
  height: 300px;
}

/* Loading Animations */
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--color-border);
  border-top: 4px solid var(--color-primary);
  border-radius: 50%;
  animation: rotate 1s linear infinite;
}

.loading-dots {
  display: flex;
  gap: var(--spacing-2);
}

.loading-dot {
  width: 8px;
  height: 8px;
  background: var(--color-primary);
  border-radius: 50%;
  animation: pulse 1.4s ease-in-out infinite both;
}

.loading-dot:nth-child(1) { animation-delay: -0.32s; }
.loading-dot:nth-child(2) { animation-delay: -0.16s; }
.loading-dot:nth-child(3) { animation-delay: 0s; }

/* Progress Indicators */
.progress-bar {
  width: 100%;
  height: 8px;
  background: var(--color-border);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--color-primary), var(--color-secondary));
  border-radius: var(--radius-full);
  transition: width 0.3s ease;
  position: relative;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* ===== ADVANCED LAYOUT PATTERNS ===== */

/* Sticky Elements */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  background: var(--color-background);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--color-border);
}

.sticky-sidebar {
  position: sticky;
  top: var(--spacing-20);
  height: fit-content;
}

/* Parallax Sections */
.parallax-container {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  perspective: 1px;
}

.parallax-element {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.parallax-back {
  transform: translateZ(-1px) scale(2);
}

.parallax-base {
  transform: translateZ(0);
}

/* Modal and Overlay Effects */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: var(--z-modal-backdrop);
  opacity: 0;
  visibility: hidden;
  transition: var(--transition-all);
}

.modal-overlay.active {
  opacity: 1;
  visibility: visible;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  background: var(--color-background);
  border-radius: var(--radius-xl);
  padding: var(--spacing-8);
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  z-index: var(--z-modal);
  transition: var(--transition-all);
}

.modal-overlay.active .modal-content {
  transform: translate(-50%, -50%) scale(1);
}

/* ===== RESPONSIVE ENHANCEMENTS ===== */

/* Container Queries (when supported) */
@container (min-width: 400px) {
  .container-responsive {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

/* Clamp for Responsive Typography */
.responsive-text-xl {
  font-size: clamp(1.5rem, 4vw, 3rem);
}

.responsive-text-lg {
  font-size: clamp(1.25rem, 3vw, 2rem);
}

.responsive-text-base {
  font-size: clamp(1rem, 2vw, 1.25rem);
}

/* Responsive Spacing */
.responsive-padding {
  padding: clamp(1rem, 5vw, 3rem);
}

.responsive-margin {
  margin: clamp(0.5rem, 3vw, 2rem);
}

/* ===== ACCESSIBILITY ENHANCEMENTS ===== */

/* Focus Indicators */
.focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius-base);
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  
  .parallax-element {
    transform: none !important;
  }
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .card-grid-item,
  .interactive-element,
  .modal-content {
    border: 2px solid;
  }
  
  .btn-hover-glow::before {
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent);
  }
}

/* ===== UTILITY CLASSES ===== */

/* Transform Utilities */
.transform-gpu {
  transform: translateZ(0);
  will-change: transform;
}

.backface-hidden {
  backface-visibility: hidden;
}

/* Overflow Utilities */
.overflow-hidden { overflow: hidden; }
.overflow-scroll { overflow: scroll; }
.overflow-auto { overflow: auto; }

/* Position Utilities */
.relative { position: relative; }
.absolute { position: absolute; }
.fixed { position: fixed; }
.sticky { position: sticky; }

/* Z-Index Utilities */
.z-0 { z-index: 0; }
.z-10 { z-index: 10; }
.z-20 { z-index: 20; }
.z-30 { z-index: 30; }
.z-40 { z-index: 40; }
.z-50 { z-index: 50; }

/* Flexbox Utilities */
.flex { display: flex; }
.inline-flex { display: inline-flex; }
.flex-col { flex-direction: column; }
.flex-row { flex-direction: row; }
.flex-wrap { flex-wrap: wrap; }
.flex-nowrap { flex-wrap: nowrap; }
.justify-start { justify-content: flex-start; }
.justify-center { justify-content: center; }
.justify-end { justify-content: flex-end; }
.justify-between { justify-content: space-between; }
.justify-around { justify-content: space-around; }
.items-start { align-items: flex-start; }
.items-center { align-items: center; }
.items-end { align-items: flex-end; }
.items-stretch { align-items: stretch; }

/* Grid Utilities */
.grid { display: grid; }
.inline-grid { display: inline-grid; }
.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
.grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
.grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }

/* Gap Utilities */
.gap-1 { gap: var(--spacing-1); }
.gap-2 { gap: var(--spacing-2); }
.gap-3 { gap: var(--spacing-3); }
.gap-4 { gap: var(--spacing-4); }
.gap-6 { gap: var(--spacing-6); }
.gap-8 { gap: var(--spacing-8); }

/* ===== PRINT STYLES ===== */
@media print {
  .no-print {
    display: none !important;
  }
  
  .print-break-before {
    break-before: page;
  }
  
  .print-break-after {
    break-after: page;
  }
  
  .print-break-inside-avoid {
    break-inside: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/frontend/styles/advanced.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C,iEAAiE;;AAEjE,iCAAiC;;AAEjC,yBAAyB;AACzB;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,kCAAkC;EAClC,iCAAiC;EACjC;;;0BAGwB;EACxB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,eAAe,iBAAiB,EAAE;AAClC,gBAAgB,kBAAkB,EAAE;AACpC,aAAa,eAAe,EAAE;AAC9B,cAAc,gBAAgB,EAAE;AAChC,eAAe,iBAAiB,EAAE;;AAElC,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,yCAAyC;;AAEzC,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA,oCAAoC;;AAEpC,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,0BAA0B,4BAA4B,EAAE;EACxD,qBAAqB,2BAA2B,EAAE;AACpD;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,wEAAwE;EAC1E;AACF;;AAEA,sBAAsB;AACtB;EACE,iDAAiD;AACnD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;AAC5D,qCAAqC,qBAAqB,EAAE;;AAE5D,mDAAmD;;AAEnD,yBAAyB;AACzB;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,+CAA+C;EAC/C,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,mBAAmB,EAAE;;AAEjD,wBAAwB;AACxB;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gFAAgF;EAChF,iCAAiC;EACjC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mFAAmF;EACnF,8BAA8B;AAChC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,yCAAyC;;AAEzC,oBAAoB;AACpB;EACE,gBAAgB;EAChB,MAAM;EACN,wBAAwB;EACxB,mCAAmC;EACnC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,mCAAmC;EACnC,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,wCAAwC;;AAExC,uCAAuC;AACvC;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;AACF;;AAEA,oCAAoC;AACpC;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2CAA2C;;AAE3C,qBAAqB;AACrB;EACE,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,uBAAuB;AACvB;EACE;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,mFAAmF;EACrF;AACF;;AAEA,gCAAgC;;AAEhC,wBAAwB;AACxB;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,gBAAgB,EAAE;AACrC,iBAAiB,cAAc,EAAE;;AAEjC,uBAAuB;AACvB,YAAY,kBAAkB,EAAE;AAChC,YAAY,kBAAkB,EAAE;AAChC,SAAS,eAAe,EAAE;AAC1B,UAAU,gBAAgB,EAAE;;AAE5B,sBAAsB;AACtB,OAAO,UAAU,EAAE;AACnB,QAAQ,WAAW,EAAE;AACrB,QAAQ,WAAW,EAAE;AACrB,QAAQ,WAAW,EAAE;AACrB,QAAQ,WAAW,EAAE;AACrB,QAAQ,WAAW,EAAE;;AAErB,sBAAsB;AACtB,QAAQ,aAAa,EAAE;AACvB,eAAe,oBAAoB,EAAE;AACrC,YAAY,sBAAsB,EAAE;AACpC,YAAY,mBAAmB,EAAE;AACjC,aAAa,eAAe,EAAE;AAC9B,eAAe,iBAAiB,EAAE;AAClC,iBAAiB,2BAA2B,EAAE;AAC9C,kBAAkB,uBAAuB,EAAE;AAC3C,eAAe,yBAAyB,EAAE;AAC1C,mBAAmB,8BAA8B,EAAE;AACnD,kBAAkB,6BAA6B,EAAE;AACjD,eAAe,uBAAuB,EAAE;AACxC,gBAAgB,mBAAmB,EAAE;AACrC,aAAa,qBAAqB,EAAE;AACpC,iBAAiB,oBAAoB,EAAE;;AAEvC,mBAAmB;AACnB,QAAQ,aAAa,EAAE;AACvB,eAAe,oBAAoB,EAAE;AACrC,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,gBAAgB,iDAAiD,EAAE;;AAEnE,kBAAkB;AAClB,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;;AAEhC,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Advanced CSS Features for S-CUBUS Website */\r\n/* Modern CSS Grid, Flexbox, Animations, and Micro-interactions */\r\n\r\n/* ===== CSS GRID LAYOUTS ===== */\r\n\r\n/* Advanced Grid System */\r\n.grid-container {\r\n  display: grid;\r\n  gap: var(--grid-gap);\r\n  width: 100%;\r\n}\r\n\r\n/* Responsive Grid Layouts */\r\n.grid-auto-fit {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: var(--spacing-6);\r\n}\r\n\r\n.grid-auto-fill {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\r\n  gap: var(--spacing-4);\r\n}\r\n\r\n/* Complex Grid Layouts */\r\n.grid-complex {\r\n  display: grid;\r\n  grid-template-columns: 1fr 2fr 1fr;\r\n  grid-template-rows: auto 1fr auto;\r\n  grid-template-areas: \r\n    \"header header header\"\r\n    \"sidebar main aside\"\r\n    \"footer footer footer\";\r\n  gap: var(--spacing-6);\r\n  min-height: 100vh;\r\n}\r\n\r\n.grid-header { grid-area: header; }\r\n.grid-sidebar { grid-area: sidebar; }\r\n.grid-main { grid-area: main; }\r\n.grid-aside { grid-area: aside; }\r\n.grid-footer { grid-area: footer; }\r\n\r\n/* Masonry-like Grid */\r\n.grid-masonry {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  grid-auto-rows: masonry;\r\n  gap: var(--spacing-6);\r\n}\r\n\r\n/* Card Grid with Subgrid */\r\n.card-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: var(--spacing-8);\r\n}\r\n\r\n.card-grid-item {\r\n  display: grid;\r\n  grid-template-rows: auto 1fr auto;\r\n  background: var(--color-surface);\r\n  border-radius: var(--radius-xl);\r\n  overflow: hidden;\r\n  transition: var(--transition-all);\r\n  border: 1px solid var(--color-border);\r\n}\r\n\r\n.card-grid-item:hover {\r\n  transform: translateY(-8px) scale(1.02);\r\n  box-shadow: var(--shadow-xl);\r\n  border-color: var(--color-primary);\r\n}\r\n\r\n/* ===== ADVANCED FLEXBOX LAYOUTS ===== */\r\n\r\n/* Flexible Navigation */\r\n.flex-nav {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: var(--spacing-4);\r\n}\r\n\r\n.flex-nav-items {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-6);\r\n  flex: 1;\r\n}\r\n\r\n.flex-nav-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-4);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Flexible Card Layouts */\r\n.flex-cards {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--spacing-6);\r\n  justify-content: center;\r\n}\r\n\r\n.flex-card {\r\n  flex: 1 1 300px;\r\n  max-width: 400px;\r\n  min-width: 280px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.flex-card-content {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n/* Centered Content with Flex */\r\n.flex-center {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n}\r\n\r\n.flex-center-column {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: var(--spacing-6);\r\n}\r\n\r\n/* Flexible Form Layouts */\r\n.flex-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--spacing-4);\r\n}\r\n\r\n.flex-form-row {\r\n  display: flex;\r\n  gap: var(--spacing-4);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.flex-form-field {\r\n  flex: 1;\r\n  min-width: 200px;\r\n}\r\n\r\n/* ===== ADVANCED ANIMATIONS ===== */\r\n\r\n/* Keyframe Animations */\r\n@keyframes slideInFromLeft {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-100px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes slideInFromRight {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(100px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes slideInFromTop {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-100px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slideInFromBottom {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(100px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes fadeInScale {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.8);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes bounceIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.3);\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n    transform: scale(1.05);\r\n  }\r\n  70% {\r\n    transform: scale(0.9);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.05);\r\n  }\r\n}\r\n\r\n@keyframes shake {\r\n  0%, 100% { transform: translateX(0); }\r\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }\r\n  20%, 40%, 60%, 80% { transform: translateX(10px); }\r\n}\r\n\r\n@keyframes rotate {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes float {\r\n  0%, 100% { transform: translateY(0px); }\r\n  50% { transform: translateY(-20px); }\r\n}\r\n\r\n@keyframes glow {\r\n  0%, 100% {\r\n    box-shadow: 0 0 5px var(--color-primary);\r\n  }\r\n  50% {\r\n    box-shadow: 0 0 20px var(--color-primary), 0 0 30px var(--color-primary);\r\n  }\r\n}\r\n\r\n/* Animation Classes */\r\n.animate-slide-in-left {\r\n  animation: slideInFromLeft 0.6s ease-out forwards;\r\n}\r\n\r\n.animate-slide-in-right {\r\n  animation: slideInFromRight 0.6s ease-out forwards;\r\n}\r\n\r\n.animate-slide-in-top {\r\n  animation: slideInFromTop 0.6s ease-out forwards;\r\n}\r\n\r\n.animate-slide-in-bottom {\r\n  animation: slideInFromBottom 0.6s ease-out forwards;\r\n}\r\n\r\n.animate-fade-in-scale {\r\n  animation: fadeInScale 0.6s ease-out forwards;\r\n}\r\n\r\n.animate-bounce-in {\r\n  animation: bounceIn 0.8s ease-out forwards;\r\n}\r\n\r\n.animate-pulse {\r\n  animation: pulse 2s ease-in-out infinite;\r\n}\r\n\r\n.animate-shake {\r\n  animation: shake 0.5s ease-in-out;\r\n}\r\n\r\n.animate-rotate {\r\n  animation: rotate 2s linear infinite;\r\n}\r\n\r\n.animate-float {\r\n  animation: float 3s ease-in-out infinite;\r\n}\r\n\r\n.animate-glow {\r\n  animation: glow 2s ease-in-out infinite;\r\n}\r\n\r\n/* Staggered Animations */\r\n.stagger-children > * {\r\n  opacity: 0;\r\n  transform: translateY(30px);\r\n  animation: slideInFromBottom 0.6s ease-out forwards;\r\n}\r\n\r\n.stagger-children > *:nth-child(1) { animation-delay: 0.1s; }\r\n.stagger-children > *:nth-child(2) { animation-delay: 0.2s; }\r\n.stagger-children > *:nth-child(3) { animation-delay: 0.3s; }\r\n.stagger-children > *:nth-child(4) { animation-delay: 0.4s; }\r\n.stagger-children > *:nth-child(5) { animation-delay: 0.5s; }\r\n.stagger-children > *:nth-child(6) { animation-delay: 0.6s; }\r\n\r\n/* ===== HOVER EFFECTS & MICRO-INTERACTIONS ===== */\r\n\r\n/* Button Hover Effects */\r\n.btn-hover-lift {\r\n  transition: var(--transition-all);\r\n}\r\n\r\n.btn-hover-lift:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.btn-hover-scale {\r\n  transition: var(--transition-all);\r\n}\r\n\r\n.btn-hover-scale:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.btn-hover-glow {\r\n  transition: var(--transition-all);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.btn-hover-glow::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);\r\n  transition: left 0.5s;\r\n}\r\n\r\n.btn-hover-glow:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n/* Card Hover Effects */\r\n.card-hover-lift {\r\n  transition: var(--transition-all);\r\n  cursor: pointer;\r\n}\r\n\r\n.card-hover-lift:hover {\r\n  transform: translateY(-10px);\r\n  box-shadow: var(--shadow-2xl);\r\n}\r\n\r\n.card-hover-tilt {\r\n  transition: var(--transition-all);\r\n  cursor: pointer;\r\n}\r\n\r\n.card-hover-tilt:hover {\r\n  transform: perspective(1000px) rotateX(5deg) rotateY(5deg);\r\n}\r\n\r\n.card-hover-zoom {\r\n  overflow: hidden;\r\n  transition: var(--transition-all);\r\n}\r\n\r\n.card-hover-zoom img {\r\n  transition: var(--transition-all);\r\n}\r\n\r\n.card-hover-zoom:hover img {\r\n  transform: scale(1.1);\r\n}\r\n\r\n/* Interactive Elements */\r\n.interactive-element {\r\n  position: relative;\r\n  transition: var(--transition-all);\r\n  cursor: pointer;\r\n}\r\n\r\n.interactive-element::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  background: rgba(var(--color-primary-rgb), 0.1);\r\n  border-radius: 50%;\r\n  transform: translate(-50%, -50%);\r\n  transition: width 0.3s, height 0.3s;\r\n}\r\n\r\n.interactive-element:hover::after {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* Ripple Effect */\r\n.ripple {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.ripple::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  border-radius: 50%;\r\n  background: rgba(var(--color-primary-rgb), 0.3);\r\n  transform: translate(-50%, -50%);\r\n  transition: width 0.6s, height 0.6s;\r\n}\r\n\r\n.ripple:active::before {\r\n  width: 300px;\r\n  height: 300px;\r\n}\r\n\r\n/* Loading Animations */\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid var(--color-border);\r\n  border-top: 4px solid var(--color-primary);\r\n  border-radius: 50%;\r\n  animation: rotate 1s linear infinite;\r\n}\r\n\r\n.loading-dots {\r\n  display: flex;\r\n  gap: var(--spacing-2);\r\n}\r\n\r\n.loading-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  background: var(--color-primary);\r\n  border-radius: 50%;\r\n  animation: pulse 1.4s ease-in-out infinite both;\r\n}\r\n\r\n.loading-dot:nth-child(1) { animation-delay: -0.32s; }\r\n.loading-dot:nth-child(2) { animation-delay: -0.16s; }\r\n.loading-dot:nth-child(3) { animation-delay: 0s; }\r\n\r\n/* Progress Indicators */\r\n.progress-bar {\r\n  width: 100%;\r\n  height: 8px;\r\n  background: var(--color-border);\r\n  border-radius: var(--radius-full);\r\n  overflow: hidden;\r\n}\r\n\r\n.progress-fill {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, var(--color-primary), var(--color-secondary));\r\n  border-radius: var(--radius-full);\r\n  transition: width 0.3s ease;\r\n  position: relative;\r\n}\r\n\r\n.progress-fill::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);\r\n  animation: shimmer 2s infinite;\r\n}\r\n\r\n@keyframes shimmer {\r\n  0% { transform: translateX(-100%); }\r\n  100% { transform: translateX(100%); }\r\n}\r\n\r\n/* ===== ADVANCED LAYOUT PATTERNS ===== */\r\n\r\n/* Sticky Elements */\r\n.sticky-header {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: var(--z-sticky);\r\n  background: var(--color-background);\r\n  backdrop-filter: blur(10px);\r\n  border-bottom: 1px solid var(--color-border);\r\n}\r\n\r\n.sticky-sidebar {\r\n  position: sticky;\r\n  top: var(--spacing-20);\r\n  height: fit-content;\r\n}\r\n\r\n/* Parallax Sections */\r\n.parallax-container {\r\n  height: 100vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  perspective: 1px;\r\n}\r\n\r\n.parallax-element {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n.parallax-back {\r\n  transform: translateZ(-1px) scale(2);\r\n}\r\n\r\n.parallax-base {\r\n  transform: translateZ(0);\r\n}\r\n\r\n/* Modal and Overlay Effects */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  backdrop-filter: blur(5px);\r\n  z-index: var(--z-modal-backdrop);\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: var(--transition-all);\r\n}\r\n\r\n.modal-overlay.active {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n.modal-content {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) scale(0.8);\r\n  background: var(--color-background);\r\n  border-radius: var(--radius-xl);\r\n  padding: var(--spacing-8);\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  overflow: auto;\r\n  z-index: var(--z-modal);\r\n  transition: var(--transition-all);\r\n}\r\n\r\n.modal-overlay.active .modal-content {\r\n  transform: translate(-50%, -50%) scale(1);\r\n}\r\n\r\n/* ===== RESPONSIVE ENHANCEMENTS ===== */\r\n\r\n/* Container Queries (when supported) */\r\n@container (min-width: 400px) {\r\n  .container-responsive {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n}\r\n\r\n/* Clamp for Responsive Typography */\r\n.responsive-text-xl {\r\n  font-size: clamp(1.5rem, 4vw, 3rem);\r\n}\r\n\r\n.responsive-text-lg {\r\n  font-size: clamp(1.25rem, 3vw, 2rem);\r\n}\r\n\r\n.responsive-text-base {\r\n  font-size: clamp(1rem, 2vw, 1.25rem);\r\n}\r\n\r\n/* Responsive Spacing */\r\n.responsive-padding {\r\n  padding: clamp(1rem, 5vw, 3rem);\r\n}\r\n\r\n.responsive-margin {\r\n  margin: clamp(0.5rem, 3vw, 2rem);\r\n}\r\n\r\n/* ===== ACCESSIBILITY ENHANCEMENTS ===== */\r\n\r\n/* Focus Indicators */\r\n.focus-visible {\r\n  outline: 2px solid var(--color-primary);\r\n  outline-offset: 2px;\r\n  border-radius: var(--radius-base);\r\n}\r\n\r\n/* Reduced Motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n  }\r\n  \r\n  .parallax-element {\r\n    transform: none !important;\r\n  }\r\n}\r\n\r\n/* High Contrast Mode */\r\n@media (prefers-contrast: high) {\r\n  .card-grid-item,\r\n  .interactive-element,\r\n  .modal-content {\r\n    border: 2px solid;\r\n  }\r\n  \r\n  .btn-hover-glow::before {\r\n    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent);\r\n  }\r\n}\r\n\r\n/* ===== UTILITY CLASSES ===== */\r\n\r\n/* Transform Utilities */\r\n.transform-gpu {\r\n  transform: translateZ(0);\r\n  will-change: transform;\r\n}\r\n\r\n.backface-hidden {\r\n  backface-visibility: hidden;\r\n}\r\n\r\n/* Overflow Utilities */\r\n.overflow-hidden { overflow: hidden; }\r\n.overflow-scroll { overflow: scroll; }\r\n.overflow-auto { overflow: auto; }\r\n\r\n/* Position Utilities */\r\n.relative { position: relative; }\r\n.absolute { position: absolute; }\r\n.fixed { position: fixed; }\r\n.sticky { position: sticky; }\r\n\r\n/* Z-Index Utilities */\r\n.z-0 { z-index: 0; }\r\n.z-10 { z-index: 10; }\r\n.z-20 { z-index: 20; }\r\n.z-30 { z-index: 30; }\r\n.z-40 { z-index: 40; }\r\n.z-50 { z-index: 50; }\r\n\r\n/* Flexbox Utilities */\r\n.flex { display: flex; }\r\n.inline-flex { display: inline-flex; }\r\n.flex-col { flex-direction: column; }\r\n.flex-row { flex-direction: row; }\r\n.flex-wrap { flex-wrap: wrap; }\r\n.flex-nowrap { flex-wrap: nowrap; }\r\n.justify-start { justify-content: flex-start; }\r\n.justify-center { justify-content: center; }\r\n.justify-end { justify-content: flex-end; }\r\n.justify-between { justify-content: space-between; }\r\n.justify-around { justify-content: space-around; }\r\n.items-start { align-items: flex-start; }\r\n.items-center { align-items: center; }\r\n.items-end { align-items: flex-end; }\r\n.items-stretch { align-items: stretch; }\r\n\r\n/* Grid Utilities */\r\n.grid { display: grid; }\r\n.inline-grid { display: inline-grid; }\r\n.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }\r\n.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\r\n.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\r\n.grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\r\n.grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }\r\n\r\n/* Gap Utilities */\r\n.gap-1 { gap: var(--spacing-1); }\r\n.gap-2 { gap: var(--spacing-2); }\r\n.gap-3 { gap: var(--spacing-3); }\r\n.gap-4 { gap: var(--spacing-4); }\r\n.gap-6 { gap: var(--spacing-6); }\r\n.gap-8 { gap: var(--spacing-8); }\r\n\r\n/* ===== PRINT STYLES ===== */\r\n@media print {\r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n  \r\n  .print-break-before {\r\n    break-before: page;\r\n  }\r\n  \r\n  .print-break-after {\r\n    break-after: page;\r\n  }\r\n  \r\n  .print-break-inside-avoid {\r\n    break-inside: avoid;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
